<template>
  <v-row no-gutters>
    <v-col cols="12" v-for="joint in test" no-gutters :key="joint.name" class="mb-1">
      <template v-if="existTests(joint)">
        <span class="subtitle-2 font-weight-medium">{{joint.name}}</span>
        <template v-if="joint.bilateral">
          <template v-for="test in joint.tests">
            <v-chip small v-if="test.right.result == true || test.right.result == false" :color="test.right.result == true ? 'green lighten-2' : 'red lighten-2'"  :key="test.id + 'right'" class="ma-1 font-weight-light">{{test.short_name}} - <translate>Right</translate></v-chip>
            <v-chip small v-if="test.left.result == true || test.left.result == false" :color="test.left.result == true ? 'green lighten-2' : 'red lighten-2'" :key="test.id + 'left'" class="ma-1 font-weight-light">{{test.short_name}} - <translate>Left</translate></v-chip>
          </template>
        </template>
        <template v-else>
          <template v-for="test in joint.tests">
            <v-chip small v-if="test.result == true || test.result == false" :color="test.result == true ? 'green lighten-2' : 'red lighten-2'"  :key="test.id" class="ma-1 font-weight-light">{{test.short_name}}</v-chip>
          </template>
        </template>
      </template>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "OsteopathyDetails",
  props: ["test"],
  data: () => ({}),
  methods: {
    existTests(joint) {
      let exist = false;
      for(let i=0; i < joint.tests.length; i++) {
        if (joint.bilateral) {
          if (joint.tests[i].right.result == true || joint.tests[i].left.result == false) {exist = true; break;}
        } else {
          if (joint.tests[i].result == true || joint.tests[i].result == false) {exist = true; break;}
        }
      }
      return exist
    }
  }
}
</script>